
import http from '../../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_SECURITY}`

export default (payload) => http.post(`${api}/permissions`, payload)
